// eslint-disable-next-line no-restricted-imports
import { Tag as AntdTag } from 'antd'
import clsx from 'clsx'
import { useMemo, type ComponentPropsWithoutRef, type FC } from 'react'

import { tagRootVariant } from './tag-variants'

type TagProps = ComponentPropsWithoutRef<typeof AntdTag>

type Props = Omit<TagProps, 'color'> & {
  size?: 'default' | 'small'
  color?:
    | 'default'
    | 'light-blue'
    | 'light-red'
    | 'light-green'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'blue-5'
    | 'green'
    | 'yellow'
    | 'red'
    | 'orange-5'
    | 'orange-6'
    | 'gray-1'
    | 'gray-2'
    | 'pink'
}

/**
 * Antd の Tag を ラップしたコンポーネント
 * - size を 追加
 * - color を 独自で管理
 */
export const Tag: FC<Props> = ({
  className,
  size = 'default',
  color = 'default',
  children,
  ...props
}) => {
  const antdColor = useMemo<TagProps['color'] | 'default'>(() => {
    switch (color) {
      case 'light-blue':
        return 'blue'
      case 'light-red':
        return 'red'
      case 'light-green':
        return 'green'
      default:
        return 'default'
    }
  }, [color])
  return (
    <AntdTag
      {...props}
      className={clsx([
        'text-center',
        tagRootVariant({ color, size }),
        className
      ])}
      color={antdColor}
    >
      {children}
    </AntdTag>
  )
}
